export namespace EeseRequirementsActions {
    export class SetAllEeseRequirements {
        static readonly type = '[EeseRequirements] SetAllEeseRequirements';
        constructor() {}
    }
}
